import { Straight } from '@mui/icons-material';
import { IconButton, Stack, Tooltip, useTheme } from '@mui/material';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { ItemPriority } from '@retail/products/types';
import { Chip } from '@shared/components';

interface Props {
  priority: ItemPriority;
  handlePriorityChange: () => void;
}

export function EditablePriorityCell({ priority, handlePriorityChange }: Props) {
  const t = useMyAssortmentTFunction();
  const theme = useTheme();
  const { tint } = theme.vars.palette.semantic;
  return (
    <Stack flexDirection="row" alignItems="center" gap={0.5}>
      {priority === ItemPriority.TEN ? (
        <Tooltip title={t('myAssortment.priority.mainPrioSupplier')}>
          <Chip
            rounded
            backgroundColor={tint.green.medium}
            textColor={tint.green.text}
            label={t('myAssortment.priority.mainPrio')}
          />
        </Tooltip>
      ) : (
        <Tooltip title={t('myAssortment.priority.underPrioSupplier')}>
          <Chip
            rounded
            backgroundColor={tint.saffron.medium}
            textColor={tint.saffron.text}
            label={t('myAssortment.priority.underPrio')}
          />
        </Tooltip>
      )}

      <IconButton sx={{ p: 0 }} onClick={handlePriorityChange}>
        {priority === ItemPriority.TEN ? (
          <Straight sx={{ rotate: '180deg' }} fontSize="small" />
        ) : (
          <Straight fontSize="small" />
        )}
      </IconButton>
    </Stack>
  );
}
